export default "__VITE_ASSET__vP4il_FS__"